<script lang="ts">
  // Activity row actor: machine art | cybo face | the Chats sidebar's session glyph | person.
  import Avatar from "../Avatar.svelte";
  import CyboSessionAvatar from "../CyboSessionAvatar.svelte";
  import { authState, workspaceState } from "$lib/state/app.svelte.js";
  import { cyboState, daemonState } from "$lib/plugins/agents/state.svelte.js";
  import { resolveActorVisual } from "$lib/agent-avatar.js";
  import { MACHINE_AVATAR, machineKindFor } from "$lib/machine-avatar.js";

  let {
    actorId,
    actorName,
    width,
    fontSize,
    fontWeight,
    isAgent,
    machineId,
  }: {
    actorId: string | null;
    actorName: string;
    width: number;
    fontSize: number;
    fontWeight?: number | string;
    /** Caller knows the actor is an agent (message fromType) — see resolveActorVisual. */
    isAgent?: boolean;
    /** The daemon that raised the row (ActivityItem.machineId): the machine is the actor. */
    machineId?: string;
  } = $props();

  // A workspace machine draws the cube, a personal one (or one the roster lacks) the laptop.
  const machine = $derived(
    machineId ? machineKindFor(machineId, (id) => daemonState.byId(id)) : null,
  );

  const visual = $derived(
    resolveActorVisual({
      actorId,
      actorName,
      cybos: cyboState.list,
      agents: workspaceState.agents,
      isAgent,
      isMember: (id) => workspaceState.members?.some((m) => m.userId === id) ?? false,
    }),
  );
</script>

{#if machine}
  <span class="contents" data-testid="machine-avatar" data-machine-kind={machine}>
    <Avatar name={actorName} image={MACHINE_AVATAR[machine]} {width} {fontSize} {fontWeight} />
  </span>
{:else if visual.kind === "session"}
  <CyboSessionAvatar agent={visual.agent} size={width} />
{:else}
  <Avatar
    name={actorName}
    image={actorId ? authState.getMemberImage(actorId) : null}
    avatar={visual.kind === "cybo" ? visual.avatar : undefined}
    {width}
    {fontSize}
    {fontWeight}
  />
{/if}
